import React from 'react';
import { OrderCombination } from '../interfaces';
import DiscountValuePad from './DiscountValuePad';

interface AddCombinationDiscountPopupProps {
    combination: OrderCombination | any;
    onClose: () => void;
    onDiscountSubmit: (value: number, discountType: string) => void;
}

const AddCombinationDiscountPopup: React.FC<AddCombinationDiscountPopupProps> = ({ onClose, combination, onDiscountSubmit }) => {
    const base = combination?.price != null ? Number(combination.price) : undefined;
    return (
        <DiscountValuePad
            title="Add discount"
            subtitle={combination?.combinationName}
            initialValue={combination?.discount}
            initialType={combination?.discountType}
            baseAmount={base}
            onClose={onClose}
            onSubmit={onDiscountSubmit}
        />
    );
};

export default AddCombinationDiscountPopup;
